import { useEffect, useState } from "react";
import { DocumentContentActions } from "../../documentsApi";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { unwrapResult } from "@reduxjs/toolkit";
import { LoadingContainer } from "../../../../app/LoadingContainer";
import { selectDocument } from "../../documentSlice";
import DeviceDataSectionMock from "./DeviceDataSectionMock";
import { APIError } from "../../../../app/appTypes";
import { impossible } from "../../../../app/Utils";
import { loadDocumentValidatedObject } from "../../../project/validationProcess/validatedObjectApi";
import { ServerErrorMsg } from "../../../../app/ServerErrorMsg";
import { SectionContentLoader } from "../../SectionContent";


export interface ValidatedObjectSectionViewProps {
    documentId: number
    sectionId: string
    actions: DocumentContentActions[],
    enablePreview?: boolean
}

export const ValidatedObjectSectionView = ({ documentId, sectionId, actions, enablePreview = false }: ValidatedObjectSectionViewProps) => {
    const dispatch = useAppDispatch()

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { validatedObject: vo, header } = useAppSelector(selectDocument)?.doc ?? impossible()

    const [err, setErr] = useState<APIError | null>(null)

    useEffect(() => {
        if (!vo) {
            setIsLoading(true)
            dispatch(loadDocumentValidatedObject(header.id))
                .then(unwrapResult)
                .catch(err => setErr(err as APIError))
                .finally(() => setIsLoading(false))
        }
    }, [])

    // ======================================================
    //  Render
    // ======================================================
    if (err) {
        return <>
            <ServerErrorMsg err={err} />
        </>
    }

    if (isLoading) {
        return <>
            <LoadingContainer />
        </>
    }

    if (vo) {
        return <SectionContentLoader sectionId={sectionId}>
            <DeviceDataSectionMock validatedObject={vo} sectionId={sectionId} />
        </SectionContentLoader>
    }

    return null
};

